import React from 'react';
import Guidance from '../defaults/Guidance';

export default (props) => {
  return (
    <Guidance />
  );
}
